(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["automatic-review-feed"] && !Shopify.designMode) return;
  try {
    (() => {
    const config=document.querySelector('[data-fd-review-feed]');
    if(!config||window.fdReviewFeedStarted)return;
    window.fdReviewFeedStarted=true;
    const labels=config.dataset;
    let latest=null,gallerySignature='';
    function updateSummaries(data,combined=true) {
      const label=(combined?labels.countLabel:labels.websiteLabel).replace('__COUNT__',String(data.count));
      const rating=Number(data.rating).toFixed(1),source=combined?labels.sourceLabel:labels.websiteSource;
      document.querySelectorAll('[data-fd-review-count]').forEach(e=>{e.textContent=label;});
      document.querySelectorAll('[data-fd-review-rating]').forEach(e=>{e.textContent=rating;});
      document.querySelectorAll('[data-fd-review-summary]').forEach(e=>{e.title=source;if(e.hasAttribute('aria-label'))e.setAttribute('aria-label',`${rating} / 5 · ${label}`);});
      document.querySelectorAll('[data-fd-review-source]').forEach(e=>{e.textContent=source;});
      document.querySelectorAll('.product-info__rating .jdgm-prev-badge__stars').forEach(e=>{
        e.dataset.score=rating;
        const score=Math.min(5,Math.max(0,Number(rating)));
        e.style.setProperty('--fd-pumpkin-fill',`${Math.round((score-Math.floor(score))*100)}%`);
        e.querySelectorAll('.jdgm-star').forEach((star,i)=>{star.classList.remove('jdgm--on','jdgm--half','jdgm--off');star.classList.add(i+1<=Math.floor(score)?'jdgm--on':i<score?'jdgm--half':'jdgm--off');});
      });
    }
    function thumbnailFor(item) {
      try {
        const url=new URL(item.thumbnail||item.url);
        if(url.hostname==='cdn.shopify.com'&&url.pathname.startsWith('/b/shop-server-review-media-production/')) {
          url.searchParams.set('width','320');url.searchParams.set('height','320');url.searchParams.set('crop','center');
        } else if(url.hostname==='review-images.judgeme.com') {
          url.searchParams.set('width','320');url.searchParams.set('quality','80');
        }
        return url.href;
      } catch { return ''; }
    }
    function renderMedia(media) {
      if (Array.isArray(media) && media.length) {
        window.fdCustomerMedia = media;
        document.dispatchEvent(new CustomEvent('fd:customer-media', {detail:media}));
      }
      const box=document.getElementById('combined-reviews');
      if(!box||!Array.isArray(media)||!media.length)return;
      const signature=media.map(m=>m.url).join('|');
      if(signature===gallerySignature)return;
      const openDialog=document.querySelector('.fd-review-media__dialog[open]');
      if(openDialog){openDialog.addEventListener('close',()=>renderMedia(media),{once:true});return;}
      gallerySignature=signature;
      document.querySelector('.fd-review-media')?.remove();
      document.querySelector('.fd-review-media__dialog')?.remove();
      const section=document.createElement('section');section.className='fd-review-media';section.setAttribute('aria-label',labels.mediaHeading);
      const heading=document.createElement('h2');heading.className='fd-review-media__heading';heading.textContent=labels.mediaHeading;
      const grid=document.createElement('div');grid.className='fd-review-media__grid';section.append(heading,grid);
      const dialog=document.createElement('dialog');dialog.className='fd-review-media__dialog';dialog.setAttribute('aria-label',labels.mediaHeading);
      const toolbar=document.createElement('div');toolbar.className='fd-review-media__toolbar';
      const previous=document.createElement('button'),next=document.createElement('button'),close=document.createElement('button'),position=document.createElement('span');
      previous.textContent='←';previous.setAttribute('aria-label',labels.previousLabel);next.textContent='→';next.setAttribute('aria-label',labels.nextLabel);close.textContent=labels.closeLabel;
      toolbar.append(previous,position,next,close);
      const viewer=document.createElement('div');viewer.className='fd-review-media__viewer';dialog.append(toolbar,viewer);document.body.append(dialog);
      let selected=0,opener=null;
      function show(index) {
        selected=(index+media.length)%media.length;
        const item=media[selected];position.textContent=`${selected+1} / ${media.length}`;viewer.replaceChildren();
        const element=document.createElement(item.type==='video'?'iframe':'img');
        element.src=item.url;
        if(item.type==='video'){element.title=labels.videoLabel;element.allow='fullscreen; picture-in-picture';element.setAttribute('allowfullscreen','');}
        else element.alt=labels.photoLabel;
        viewer.append(element);
      }
      previous.onclick=()=>show(selected-1);next.onclick=()=>show(selected+1);close.onclick=()=>dialog.close();
      dialog.addEventListener('close',()=>{viewer.replaceChildren();opener?.focus({preventScroll:true});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();show(selected-1);}if(e.key==='ArrowRight'){e.preventDefault();show(selected+1);}});
      media.forEach((item,index)=>{
        const button=document.createElement('button');button.type='button';button.className='fd-review-media__item';button.setAttribute('aria-label',`${item.type==='video'?labels.videoLabel:labels.photoLabel} ${index+1}`);
        if(thumbnailFor(item)){const img=document.createElement('img');img.src=thumbnailFor(item);img.alt='';img.loading=index<6?'eager':'lazy';img.decoding='async';button.append(img);}
        if(item.type==='video'){const play=document.createElement('span');play.className='fd-review-media__play';play.textContent=`▶ ${labels.videoLabel}`;button.append(play);}
        button.onclick=()=>{opener=button;show(index);dialog.showModal();};grid.append(button);
      });
      box.after(section);box.closest('.reviews-section').classList.add('fd-media-ready');
    }
    function valid(data){return data&&Number.isSafeInteger(data.count)&&data.count>0&&data.rating>=1&&data.rating<=5&&Date.now()-Date.parse(data.updatedAt)<86400000;}
    function apply(data){latest=data;updateSummaries(data);renderMedia(data.media);}
    async function sync() {
      try {
        const response=await fetch(labels.endpoint,{credentials:'omit',signal:AbortSignal.timeout(45000)});
        if(!response.ok)throw Error('Review feed unavailable');
        const data=await response.json();if(!valid(data))throw Error('Invalid review feed');apply(data);
        try{sessionStorage.setItem('fd-review-feed-v1',JSON.stringify(data));}catch{}
      } catch {
        if(!valid(latest)) {
          updateSummaries({count:Number(labels.websiteCount),rating:Number(labels.websiteRating)},false);
          const gallery=document.querySelector('.fd-review-media');
          if(gallery&&!gallerySignature)gallery.remove();
        }
      }
    }
    try{const cached=JSON.parse(sessionStorage.getItem('fd-review-feed-v1'));if(valid(cached))apply(cached);}catch{}
    // The native public feed keeps the gallery useful if the combined service is offline.
    async function websiteMedia() {
      try {
        const cached=JSON.parse(sessionStorage.getItem('fd-website-media-v2')||'null');
        if(cached&&Date.now()-cached.at<900000&&cached.media?.length){if(!valid(latest))renderMedia(cached.media);}
      } catch {}
      const media=[],seen=new Set();let loaded=0,total=Infinity;
      function add(type,value,thumbnail) {
        try {
          const url=new URL(value);
          if(url.protocol!=='https:'||!['review-images.judgeme.com','cdn.shopify.com','www.youtube.com','player.vimeo.com','iframe.mediadelivery.net'].includes(url.hostname))return;
          const key=url.origin+url.pathname;
          if(seen.has(key))return;seen.add(key);media.push({type,url:url.href,thumbnail});
        } catch {}
      }
      try {
        for(let page=1;loaded<total&&page<=40;page++) {
          const params=new URLSearchParams({shop_domain:'9xp85y-5j.myshopify.com',platform:'shopify',per_page:'100',review_type:'all-reviews',page:String(page)});
          const response=await fetch('https://api.judge.me/reviews/all_reviews_js_based?'+params,{credentials:'omit',signal:AbortSignal.timeout(10000)});
          if(!response.ok)throw Error('Website media unavailable');
          const data=await response.json();
          if(page===1)total=Number(data.number_of_product_reviews)+Number(data.number_of_shop_reviews);
          const doc=new DOMParser().parseFromString(data.html||'','text/html');
          const reviews=doc.querySelectorAll('.jdgm-rev');if(!reviews.length)break;loaded+=reviews.length;
          if (page === 1) {
            const recent = Array.from(reviews).map(review => ({
              id: review.dataset.reviewId,
              author: review.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Customer',
              text: review.querySelector('.jdgm-rev__body')?.textContent.trim() || '',
              rating: Number(review.querySelector('.jdgm-rev__rating')?.dataset.score),
              verified: review.dataset.verifiedBuyer === 'true'
            })).filter(review => review.text.length > 0 && review.text.length <= 230).slice(0,12);
            document.dispatchEvent(new CustomEvent('fd:customer-reviews', {detail:recent}));
          }
          doc.querySelectorAll('.jdgm-rev__pic-link[href]').forEach(link=>{const url=link.getAttribute('href');add('image',url,url.replace(/width=\d+/,'width=480'));});
          doc.querySelectorAll('.jdgm-yt-video[data-id]').forEach(video=>{const id=video.dataset.id;if(/^[\w-]{11}$/.test(id))add('video','https://www.youtube.com/embed/'+id,'https://img.youtube.com/vi/'+id+'/hqdefault.jpg');});
          doc.querySelectorAll('.jdgm-vid-player[data-external-id]').forEach(video=>{
            const id=video.dataset.externalId;
            if(/^[a-f0-9-]{36}$/i.test(id))add('video','https://iframe.mediadelivery.net/embed/748386/'+id+'?preload=false','https://review-videos.judgeme.com/'+id+'/thumbnail.jpg');
            else if(/^\d+$/.test(id))add('video','https://player.vimeo.com/video/'+id,null);
          });
          if(!valid(latest)&&media.length)renderMedia(media);
        }
        if(media.length&&loaded>=total)try{sessionStorage.setItem('fd-website-media-v2',JSON.stringify({at:Date.now(),media}));}catch{}
      } catch { /* The real Judge.me gallery remains visible until media is available. */ }
    }
    websiteMedia();
    sync();setInterval(()=>{if(!document.hidden)sync();},900000);
    document.addEventListener('shopify:section:load',()=>{if(latest){gallerySignature='';apply(latest);}});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["combined-review-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-write-store-review]');
    if (!button) return;
    var section = button.closest('.reviews-section');
    var nativeLink = section && section.querySelector('.jdgm-all-reviews-widget .jdgm-write-rev-link');
    if (!nativeLink) return;
    if (nativeLink.getAttribute('aria-expanded') !== 'true') nativeLink.click();
    requestAnimationFrame(function() {
      var form = section.querySelector('.jdgm-form-wrapper .jdgm-form');
      if (form && nativeLink.getAttribute('aria-expanded') === 'true') {
        form.setAttribute('tabindex', '-1');
        form.focus({ preventScroll: true });
        form.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
